import { ThunkAction } from 'redux-thunk';
import { AxiosResponse } from 'axios';
import store from 'store';
import ApiClient, { createTokenConfig, isCancelled } from 'api/ApiClient';
import { NotificationsAction, showError } from '@spike/notifications-action';
import {
    PET_BREAKDOWN_REPORT_GET_START,
    PET_BREAKDOWN_REPORT_GET_SUCCESS,
    PET_BREAKDOWN_REPORT_GET_ERROR,
    PetBreakdownReportAction
} from './PetBreakdownReportActionsTypes';
import { PetBreakdownReportDto } from './PetBreakdownReportDto';
import { convertToPetBreakdownReport } from './petBreakdownReportConverter';
import { PetBreakdownReport } from 'model/ClientAndPetsReport';

export const getPetBreakdownReport = (
    start?: string,
    end?: string,
    page?: number,
    size?: number
): ThunkAction<void, null, null, PetBreakdownReportAction | NotificationsAction> => {
    return async dispatch => {
        dispatch(getStart());

        const { marketplaceId } = store.getState().login.auth;
        let url = `/pet_breakdown_report?marketplace_id=${marketplaceId}`;

        if (start) url += `&start=${start}`;
        if (end) url += `&end=${end}`;
        if (page) url += `&page=${page}`;
        if (size) url += `&size=${size}`;

        try {
            const response: AxiosResponse<PetBreakdownReportDto> = await ApiClient.get(
                url,
                createTokenConfig(store.getState().login.auth.token!)
            );

            dispatch(getSuccess(convertToPetBreakdownReport(response.data)));
        } catch (apiError) {
            if (!isCancelled(apiError)) {
                dispatch(getError());
                dispatch(showError('Too many records to display. Please try a shorter date range.'));
            }
        }
    };
};

const getStart = (): PetBreakdownReportAction => ({
    type: PET_BREAKDOWN_REPORT_GET_START
});

const getSuccess = (report: PetBreakdownReport): PetBreakdownReportAction => ({
    type: PET_BREAKDOWN_REPORT_GET_SUCCESS,
    payload: { report }
});

const getError = (): PetBreakdownReportAction => ({
    type: PET_BREAKDOWN_REPORT_GET_ERROR
});
